<template>
  <div class="vip-contain">
    <p class="title">开通{{ target.name }}</p>
    <template v-if="item.expiredAt">
      <span class="date">{{ item.expiredAt | dateFormat }}前有效</span>
    </template>
    <template v-else>
      <span class="date">{{ item.createdAt | dateFormat }}创建的订单</span>
    </template>
  </div>
</template>

<script>
export default {
  name: 'VipContain',
  props: {
    item: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  computed: {
    target () {
      return this.item.target
    }
  }
}
</script>

<style scoped lang="scss">
.vip-contain {
  .title {
    @include sc($font-size-lg, $color-text-heavy);
    padding-bottom: 8px;
  }
  .date {
    @include sc($font-size-md, $color-text-light);
  }
}
</style>
